import { LyVariantChangedEventListener } from "./base"

if (!customElements.get('ly-main-product')) {
    customElements.define('ly-main-product', class extends LyVariantChangedEventListener {

        connectedCallback() {
            super.connectedCallback()
        }

        disconnectedCallback() {
            super.disconnectedCallback()
        }

        _onVariantChange = ({ variantId, activedKey, activedOptions }) => {
            window.history.replaceState({}, '', `${this.dataset.productUrl}?variant=${variantId}`)
            // this.updateByFetch(activedOptions)
        }

        updateByFetch = async (activedOptions) => {
            const params = []
            params.push(`section_id=${this.dataset.sectionId}`)
            if (activedOptions.length > 0) {
                params.push(`option_values=${activedOptions.join(',')}`)
            }

            const url = `${this.dataset.productUrl}?${params.join('&')}`
            try {
                const response = await fetch(url)
                const text = await response.text()
                const html = new DOMParser().parseFromString(text, 'text/html')

                const oldOverviewMobile = this.querySelector('.ly-main-product-overview.ly-hide-desktop')
                const oldOverviewDesktop = this.querySelector('.ly-main-product-overview.ly-hide-mobile')

                const newOverviewMobile = html.querySelector('.ly-main-product-overview.ly-hide-desktop')
                const newOverviewDesktop = html.querySelector('.ly-main-product-overview.ly-hide-mobile')

                const selector = '.ly-main-product-overview-specification'
                oldOverviewMobile.querySelector(selector).replaceWith(newOverviewMobile.querySelector(selector))
                oldOverviewDesktop.querySelector(selector).replaceWith(newOverviewDesktop.querySelector(selector))
            } catch (error) {
                throw error
            }
        }
    })
}